'use strict';


function getAccessKey(x) {
  return String.fromCharCode(x + 97 | 0);
}

exports.getAccessKey = getAccessKey;
/* No side effect */
